import React, { useEffect, useState, useContext, createContext } from 'react';
import HekaosLogoImg from '../data/Hekaos_Logo.png';

export const DEFAULT_CONFIG = {
  brand: {
    name: 'HEKAOS',
    taglines: {
      primary: 'Engineering Order from Chaos | Where Ancient Wisdom Meets Cutting-Edge AI',
      ai: 'Where Ancient Wisdom Meets Cutting-Edge AI',
    },
    activeTagline: 'primary',
  },

  system: {
    bottomBarMessage: 'HEKAOS Core Engine Operational • AI Modules Synced • All Systems Nominal',
  },
  orbitingTags: {
    home: [
      { label: 'EONIRA', gradient: 'from-amber-400 to-orange-600', pulse: true },
      { label: 'Heka', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: 'Oracular Intelligence', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: 'ORDER', gradient: 'from-emerald-400 to-lime-500', pulse: false },
      { label: 'CHAOS', gradient: 'from-red-400 to-rose-600', pulse: false },
      { label: '.', gradient: 'from-indigo-400 to-blue-600', pulse: false },
      { label: '.', gradient: 'from-purple-400 to-pink-600', pulse: true },
      { label: '.', gradient: 'from-teal-400 to-cyan-600', pulse: false },
      { label: '.', gradient: 'from-yellow-400 to-amber-600', pulse: false },
      { label: '.', gradient: 'from-blue-400 to-indigo-600', pulse: false },
      { label: '.', gradient: 'from-fuchsia-400 to-purple-600', pulse: false },
      { label: '.', gradient: 'from-green-400 to-emerald-600', pulse: false },
      { label: '.', gradient: 'from-pink-400 to-rose-600', pulse: true },
      { label: '.', gradient: 'from-sky-400 to-blue-600', pulse: false },
      { label: '.', gradient: 'from-orange-400 to-red-600', pulse: false },
    ],
     intelligence: [
      { label: 'Noesis', gradient: 'from-cyan-400 to-sky-600', pulse: true },
      { label: 'Simulation', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: 'Foresight', gradient: 'from-amber-400 to-orange-600', pulse: false },
      { label: 'Reasoning', gradient: 'from-emerald-400 to-lime-500', pulse: false },
      { label: 'Strategic AI', gradient: 'from-red-400 to-rose-600', pulse: false },
    ],

    connect: [
      { label: 'Nexus', gradient: 'from-emerald-400 to-lime-500', pulse: true },
      { label: 'Collaboration', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: 'Integration', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: 'Execution', gradient: 'from-amber-400 to-orange-600', pulse: false },
    ],

    vision: [
      { label: 'Axiom', gradient: 'from-amber-400 to-orange-600', pulse: true },
      { label: 'First Principles', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: 'Systems Thinking', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: 'CHAOS', gradient: 'from-amber-400 to-orange-600', pulse: true },
      { label: '.', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: '.', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: '.', gradient: 'from-amber-400 to-orange-600', pulse: true },
      { label: '.', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: '.', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: '.', gradient: 'from-amber-400 to-orange-600', pulse: true },
      { label: '.', gradient: 'from-violet-400 to-fuchsia-600', pulse: false },
      { label: '.', gradient: 'from-cyan-400 to-sky-600', pulse: false },
    ],

    career: [
      { label: 'Builders', gradient: 'from-violet-400 to-fuchsia-600', pulse: true },
      { label: 'Engineers', gradient: 'from-cyan-400 to-sky-600', pulse: false },
      { label: 'Architects', gradient: 'from-amber-400 to-orange-600', pulse: false },
    ],

    default: [
      { label: 'HEKAOS', gradient: 'from-amber-400 to-orange-600', pulse: true },
    ],
  },
  assets: {
    logo: HekaosLogoImg,
  },
};

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const result = await window.storage.get('hekaos-config');
      if (result?.value) {
        setConfig(JSON.parse(result.value));
      }
    } catch (error) {
      console.error('Failed to load config:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateConfig = async (newConfig) => {
    setConfig(newConfig);
    try {
      await window.storage.set('hekaos-config', JSON.stringify(newConfig));
    } catch (error) {
      console.error('Failed to save config:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-black flex items-center justify-center">
        <div className="text-amber-400 text-2xl animate-pulse">Loading HEKAOS...</div>
      </div>
    );
  }

  return (
    <ConfigContext.Provider
      value={{
        config,
        updateConfig,
        resetConfig: () => setConfig(DEFAULT_CONFIG),
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) throw new Error('useConfig must be used within ConfigProvider');
  return context;
};

